export const c_log_viewer__list_item_m_current_BackgroundColor = {
  "name": "--pf-c-log-viewer__list-item--m-current--BackgroundColor",
  "value": "#f9e0a2",
  "var": "var(--pf-c-log-viewer__list-item--m-current--BackgroundColor)"
};
export default c_log_viewer__list_item_m_current_BackgroundColor;